export default __webpack_public_path__ + "static/media/PostulantIcon.cf7c55cc.svg";